var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgApple = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 20,
  fill: "none",
  viewBox: "0 0 17 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#7fiXhC__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00664F",
  d: "M9.314 1.718c-.57.598-.93 1.243-1.075 1.827C7.373 2.367 6.194 1.812 5.41 1.67a.69.69 0 0 0-.79.584c-.066.39.181.764.553.836.113.021 2.797.587 2.797 4.171 0 .396.31.72.687.72s.687-.324.687-.72c0-.695-.086-1.307-.23-1.855.722.159 1.718-.245 2.601-1.17C12.889 3.006 13.357 0 13.357 0s-2.87.49-4.042 1.718"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#008264",
  d: "M10.991 6.32c-.896 0-1.742.508-2.491.818-.75-.31-1.594-.818-2.491-.818C2.964 6.32.5 7.945.5 12.235s2.464 7.767 5.505 7.767c.897 0 1.742-.306 2.492-.843.749.537 1.594.843 2.491.843 3.041 0 5.505-3.476 5.505-7.767 0-4.29-2.464-5.915-5.505-5.915z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "7fiXhC__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.5 0h16v20H.5z"
})))));
export default SvgApple;